import request from "@/util/http";
import qs from "qs"; // 办事大厅主题查询

export var getSubjectVoList = function getSubjectVoList() {
  return request({
    url: "/admin/homeServe/getSubjectVoList",
    method: "get"
  });
}; // 办事大厅专题查询

export var getTopicVoList = function getTopicVoList() {
  return request({
    url: "/admin/homeServe/getTopicVoList",
    method: "get"
  });
}; // 办事大厅服务查询

export var getServeVoList = function getServeVoList(params) {
  return request({
    url: "/admin/homeServe/getServeVoList",
    method: "get",
    params: params
  });
}; // 收藏、取消收藏

export var favorOrRecall = function favorOrRecall(data) {
  return request({
    url: "/admin/homeServe/favorOrRecall",
    method: "post",
    data: qs.stringify(data)
  });
}; // 服务详情

export var getServeDetail = function getServeDetail(id) {
  return request({
    url: "/admin/homeServe/getServe?serve_id=".concat(id),
    method: "get"
  });
}; // 获取服务评价列表

export var serveEvaluateBigVoList = function serveEvaluateBigVoList(params) {
  return request({
    url: "/admin/homeServe/getServeEvaluateBigVoList",
    method: "get",
    params: params
  });
}; // 获取服务评价信息

export var serveEvaluateSmallVo = function serveEvaluateSmallVo(params) {
  return request({
    url: "/admin/homeServe/getServeEvaluateSmallVo",
    method: "get",
    params: params
  });
}; // 获取服务评价类型

export var serveEvaluateTypeVoList = function serveEvaluateTypeVoList(params) {
  return request({
    url: "/admin/homeServe/getServeEvaluateTypeVoList",
    method: "get",
    params: params
  });
}; // 获取服务满意度

export var serveSatisfactionVoList = function serveSatisfactionVoList(params) {
  return request({
    url: "/admin/homeServe/getServeSatisfactionVoList",
    method: "get",
    params: params
  });
}; // 提交服务评价

export var handleServeEvaluate = function handleServeEvaluate(params) {
  return request({
    headers: {
      "Content-Type": "application/json"
    },
    url: "/admin/homeServe/submitServeEvaluate",
    method: "post",
    data: JSON.stringify(params)
  });
}; // 获取制筛选项

export var getCustom = function getCustom() {
  return request({
    url: "/admin/homeServe/getCustom",
    method: "get"
  });
}; // 定制/取消定制筛选项

export var handlecustomOrRecall = function handlecustomOrRecall(params) {
  return request({
    url: "/admin/homeServe/customOrRecall",
    method: "post",
    params: params
  });
};